import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BusyService } from '../../../services/busy.service';

/**
 * Voile d'attente affiché pendant un travail long et non interruptible.
 *
 * Posé une seule fois dans la coquille applicative, comme la fenêtre de
 * confirmation et les notifications. Il recouvre l'écran entier : pendant une
 * suppression de plage, la grille montre encore des lignes déjà détruites, et
 * tout clic sur ces lignes partirait sur des données fausses.
 */
@Component({
  selector: 'ces-busy-overlay',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProgressSpinnerModule, TranslocoModule],
  templateUrl: './ces-busy-overlay.component.html',
})
export class CesBusyOverlayComponent {
  protected readonly busy = inject(BusyService);
}
